/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  EnableAffiliateReferrerOptions,
  EnableAffiliateReferrerStatus200,
  EnableAffiliateReferrerStatus400,
  EnableAffiliateReferrerStatus401,
  EnableAffiliateReferrerStatus403,
  EnableAffiliateReferrerStatus404,
  EnableAffiliateReferrerStatus500,
} from '../types/EnableAffiliateReferrer'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { enableAffiliateReferrer } from '../clients/enableAffiliateReferrer'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const enableAffiliateReferrerMutationKey = () =>
  [{ url: '/v1/affiliate_programs/:program_id/referrers/:referrer_id/enable' }] as const

export function enableAffiliateReferrerMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = enableAffiliateReferrerMutationKey()
  return mutationOptions<
    EnableAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | EnableAffiliateReferrerStatus400
      | EnableAffiliateReferrerStatus401
      | EnableAffiliateReferrerStatus403
      | EnableAffiliateReferrerStatus404
      | EnableAffiliateReferrerStatus500
    >,
    EnableAffiliateReferrerOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return enableAffiliateReferrer({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Uses the same ADMIN, tenant INTEGRATOR, and assigned-program AFFILIATE_MANAGER permissions as disabling. Clears disabled_at and disabled_by on the existing membership, preserving its ID, user, program, codes, customization, and attribution history. Already enabled returns 200 unchanged. Unknown or wrong-program members return 404. Does not unpause the program or change independent signup, account, tenant, or campaign rules.
 * @summary Re-enable an existing referrer
 * {@link /v1/affiliate_programs/:program_id/referrers/:referrer_id/enable}
 */
export function useEnableAffiliateReferrer<TContext>(
  options: {
    mutation?: UseMutationOptions<
      EnableAffiliateReferrerStatus200,
      ResponseErrorConfig<
        | EnableAffiliateReferrerStatus400
        | EnableAffiliateReferrerStatus401
        | EnableAffiliateReferrerStatus403
        | EnableAffiliateReferrerStatus404
        | EnableAffiliateReferrerStatus500
      >,
      EnableAffiliateReferrerOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? enableAffiliateReferrerMutationKey()

  const baseOptions = enableAffiliateReferrerMutationOptions(config) as UseMutationOptions<
    EnableAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | EnableAffiliateReferrerStatus400
      | EnableAffiliateReferrerStatus401
      | EnableAffiliateReferrerStatus403
      | EnableAffiliateReferrerStatus404
      | EnableAffiliateReferrerStatus500
    >,
    EnableAffiliateReferrerOptions,
    TContext
  >

  return useMutation<
    EnableAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | EnableAffiliateReferrerStatus400
      | EnableAffiliateReferrerStatus401
      | EnableAffiliateReferrerStatus403
      | EnableAffiliateReferrerStatus404
      | EnableAffiliateReferrerStatus500
    >,
    EnableAffiliateReferrerOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    EnableAffiliateReferrerStatus200,
    ResponseErrorConfig<
      | EnableAffiliateReferrerStatus400
      | EnableAffiliateReferrerStatus401
      | EnableAffiliateReferrerStatus403
      | EnableAffiliateReferrerStatus404
      | EnableAffiliateReferrerStatus500
    >,
    EnableAffiliateReferrerOptions,
    TContext
  >
}
